import type { FC } from "react";

import { SIGNAL_HEX } from "../common/colorTokens";
import { type InstanceStatus } from "./blackboardModels";

export const statusMeta: Record<
  InstanceStatus,
  { accent: string; accentClass: string; label: string; pulse: boolean }
> = {
  killed: {
    accent: SIGNAL_HEX.danger,
    accentClass:
      "text-rose-700 border-rose-500/50 dark:text-rose-300 dark:border-rose-400/40",
    label: "OFFLINE",
    pulse: false,
  },
  running: {
    accent: SIGNAL_HEX.healthy,
    accentClass:
      "text-emerald-700 border-emerald-500/50 dark:text-emerald-300 dark:border-emerald-400/40",
    label: "RUNNING",
    pulse: true,
  },
  waiting: {
    accent: SIGNAL_HEX.warning,
    accentClass:
      "text-amber-700 border-amber-500/50 dark:text-amber-300 dark:border-amber-400/40",
    label: "PARKED",
    pulse: false,
  },
};

export type StatusMeta = (typeof statusMeta)[keyof typeof statusMeta];

export const CornerBracket: FC<{
  position: "tl" | "tr" | "bl" | "br";
  color: string;
}> = ({ position, color }) => {
  const map: Record<typeof position, string> = {
    bl: "bottom-1 left-1 border-b border-l",
    br: "bottom-1 right-1 border-b border-r",
    tl: "top-1 left-1 border-l border-t",
    tr: "top-1 right-1 border-r border-t",
  };
  return (
    <span
      aria-hidden
      className={`pointer-events-none absolute h-2 w-2 ${map[position]}`}
      style={{ borderColor: `${color}80` }}
    />
  );
};
